export default __webpack_public_path__ + "images/ic_reclamaciones_chatbot_2.png";